import { render, staticRenderFns } from "./Terminos.vue?vue&type=template&id=e2d7533a&"
import script from "./Terminos.vue?vue&type=script&lang=ts&"
export * from "./Terminos.vue?vue&type=script&lang=ts&"
import style0 from "./Terminos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports